var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 5.625L9.72292 7.56375L12.0417 5.39125L12.0417 16.625L14.9583 16.625L14.9583 5.39125L17.2625 7.56375L19.3333 5.625L13.5 0.124999L7.66667 5.625ZM3.29167 22.125L3.29167 12.5L0.374999 12.5L0.375 22.125C0.375 23.6375 1.6875 24.875 3.29167 24.875L23.7083 24.875C25.3125 24.875 26.625 23.6375 26.625 22.125L26.625 12.5L23.7083 12.5L23.7083 22.125L3.29167 22.125Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportDocument);
export default __webpack_public_path__ + "static/media/ImportDocument.bbedf50a1160f69ca3ffccbbb5d24337.svg";
export { ForwardRef as ReactComponent };